import React from "react";
import { Alert, Button, Card, Checkbox, Modal, Space, Typography } from "antd";
import { Link } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import { useCookieConsent } from "../context/CookieConsentContext";

const { Text } = Typography;

export default function CookieConsentBanner() {
  const { t } = useTranslation();
  const {
    bannerVisible,
    settingsModalOpen,
    settingsDraft,
    setSettingsDraft,
    acceptAll,
    rejectAll,
    openSettings,
    closeSettings,
    saveConfigured,
    infoUrl,
  } = useCookieConsent();

  return (
    <>
      {bannerVisible && (
        <div
          style={{
            position: "fixed",
            left: 16,
            right: 16,
            bottom: 16,
            zIndex: 1200,
          }}
        >
          <Card
            style={{
              boxShadow: "0 12px 30px rgba(0, 0, 0, 0.2)",
              border: "1px solid #d9e4f5",
            }}
          >
            <Space direction="vertical" size={12} style={{ width: "100%" }}>
              <Text>
                <Trans
                  i18nKey="cookieConsent.bannerText"
                  components={{ legalLink: <Link to={infoUrl} /> }}
                />
              </Text>
              <Space wrap>
                <Button type="primary" onClick={acceptAll}>
                  {t("cookieConsent.acceptAll")}
                </Button>
                <Button onClick={rejectAll}>{t("cookieConsent.rejectAll")}</Button>
                <Button type="dashed" onClick={openSettings}>
                  {t("cookieConsent.configure")}
                </Button>
              </Space>
            </Space>
          </Card>
        </div>
      )}

      <Modal
        title={t("cookieConsent.configureTitle")}
        open={settingsModalOpen}
        onCancel={closeSettings}
        onOk={() => saveConfigured(settingsDraft)}
        okText={t("cookieConsent.savePreferences")}
      >
        <Space direction="vertical" style={{ width: "100%" }}>
          <Alert
            type="info"
            showIcon
            message={t("cookieConsent.chooseCategories")}
          />
          <Checkbox
            checked={settingsDraft.first_party}
            onChange={(e) =>
              setSettingsDraft((prev) => ({
                ...prev,
                first_party: e.target.checked,
              }))
            }
          >
            {t("cookieConsent.firstPartyLabel")}
          </Checkbox>
          <Checkbox
            checked={settingsDraft.third_party}
            onChange={(e) =>
              setSettingsDraft((prev) => ({
                ...prev,
                third_party: e.target.checked,
              }))
            }
          >
            {t("cookieConsent.thirdPartyLabel")}
          </Checkbox>
        </Space>
      </Modal>
    </>
  );
}
